import SurveyForm from '../../components/SurveyForm/SurveyForm';
import { CREATE_SURVEY } from '../../constants';

function SurveyCreation() {
  return <SurveyForm type={CREATE_SURVEY} />;
}

export default SurveyCreation;
